import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer';
import Header from '../Header';
import MednaBrand from '../../config/MednaBrand';

export default function Layout() {
  return (
    <>
      <Header logoSrc={MednaBrand.logo} variant="cs_heading_color" />
      <Outlet />
      <Footer />
    </>
  );
}
